import { ReactNode, useState } from "react";
import "./Expander.scss";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { MinusCircleIcon, PlusCircleIcon } from "/App.Components";

interface Props {
  heading: string;
  children: ReactNode;
  ariaLabelExpand: string;
  ariaLabelCollapse: string;
}

const Expander = ({
  heading,
  children,
  ariaLabelCollapse,
  ariaLabelExpand,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="expander-norad">
      <h2 className="expander-norad__screen-reader-heading">{heading}</h2>
      <button
        className="expander-norad__heading-row"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? ariaLabelCollapse : ariaLabelExpand}
      >
        <span className="expander-norad__button-text">{heading}</span>
        <span className="expander-norad__icon-container">
          {isOpen ? (
            <MinusCircleIcon
              size="20"
              thickness="Thin"
              color={ColorTheme.iconStrong}
            />
          ) : (
            <PlusCircleIcon
              size="20"
              thickness="Thin"
              color={ColorTheme.iconStrong}
            />
          )}
        </span>
      </button>
      {isOpen && children && (
        <div className="expander-norad__children">{children}</div>
      )}
    </div>
  );
};
export default Expander;
